<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>All Product Groups</h2>

    <div>
      <button class='btn btn-secondary' routerLink='/warehousing/product-groups/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <app-grid
    entity='product-group'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
  ></app-grid>
</div>
